















































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SzksResultShijuangailan extends Vue {
  @Prop()
  private result;
  @Prop()
  private exam;
  @Prop()
  private student;
  @Prop()
  private leftTime;
  private jump(index) {
    this.$emit("jump", index);
  }
}
